






















































import Vue from "vue";

import AchievementBronze from "@joyz/app-core/assets/trophy/achievements/Bronze.svg";
import AchievementSilver from "@joyz/app-core/assets/trophy/achievements/Silver.svg";
import AchievementGold from "@joyz/app-core/assets/trophy/achievements/Gold.svg";

import IconCheckCircleActive from "@joyz/app-core/assets/icons/active/CheckCircle.svg";

import TrophyBronzeStandard from "@joyz/app-core/assets/trophy/gif/Bronze.gif";
import TrophyBronzeNewRecord from "@joyz/app-core/assets/trophy/gif/BronzeNewRecord.gif";
import TrophySilverStandard from "@joyz/app-core/assets/trophy/gif/Silver.gif";
import TrophySilverNewRecord from "@joyz/app-core/assets/trophy/gif/SilverNewRecord.gif";
import TrophyGoldStandard from "@joyz/app-core/assets/trophy/gif/Gold.gif";
import TrophyGoldNewRecord from "@joyz/app-core/assets/trophy/gif/GoldNewRecord.gif";

interface Data {
  icons: { [key: string]: string };
  trophies: {
    achievement: {
      [key: number]: string;
    };
    gif: {
      [key: number]: {
        newRecord: string;
        standard: string;
      };
    };
  };
}

interface Computed {
  newRecord: boolean;
  trophyComment: string;
  trophySrc: string;
}

interface Props {
  achievement: boolean;
  exerciseResult: any;
  practiceMode: boolean;
  trophyScores?: any;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  name: "SingleSentenceReadingTrophy",
  props: {
    achievement: {
      type: Boolean,
      default: false
    },
    exerciseResult: {
      type: Object,
      default: undefined
    },
    practiceMode: {
      type: Boolean,
      default: false
    },
    trophyScores: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icons: {
        checkCircle: IconCheckCircleActive
      },
      trophies: {
        achievement: {
          1: AchievementBronze,
          2: AchievementSilver,
          3: AchievementGold
        },
        gif: {
          1: {
            newRecord: TrophyBronzeNewRecord,
            standard: TrophyBronzeStandard
          },
          2: {
            newRecord: TrophySilverNewRecord,
            standard: TrophySilverStandard
          },
          3: {
            newRecord: TrophyGoldNewRecord,
            standard: TrophyGoldStandard
          }
        }
      }
    };
  },
  computed: {
    newRecord() {
      return this.exerciseResult.prevBestTrophy < this.exerciseResult.trophy;
    },
    trophyComment() {
      return this.$__(
        `exercise.single-sentence-reading.trophy.${this.exerciseResult.trophy}`,
        this.exerciseResult.moreScore
      );
    },
    trophySrc() {
      if (this.practiceMode) return this.icons.checkCircle;

      if (!this.exerciseResult) return "";

      if (this.achievement) {
        return this.trophies.achievement[this.exerciseResult.trophy];
      }

      const trophyType = this.newRecord ? "newRecord" : "standard";

      return this.trophies.gif[this.exerciseResult.trophy][trophyType];
    }
  }
});
